import script from "./GeneralNote.vue?vue&type=script&setup=true&lang=js"
export * from "./GeneralNote.vue?vue&type=script&setup=true&lang=js"

import "./GeneralNote.vue?vue&type=style&index=0&id=fc2000d6&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc2000d6"]])

export default __exports__